<template>
    <div style='word-wrap:break-word'>
        <div class=WordSection1>

            <p class=MsoNoSpacing align=center style='text-align:center;background:white'>
                <span style='color:black'></span><b>
                    <span style='font-size:12.0pt;
font-family:"Times New Roman",serif;color:black'>
                        6698 SAYILI KİŞİSEL VERİLERİN
                        KORUNMASI KANUNU (“KVKK”) UYARINCA KİŞİSEL VERİLERİN KORUNMASI HAKKINDA
                    </span>
                </b>
            </p>

            <p class=MsoNoSpacing align=center style='text-align:center;background:white'>
                <b>
                    <span style='font-size:12.0pt;font-family:"Times New Roman",serif;color:black'>
                        UYARINCA
                        KİŞİSEL VERİLERİNİZİN KORUNMASI HAKKINDA
                    </span>
                </b>
            </p>

            <p class=MsoNoSpacing align=center style='text-align:center;background:white'>
                <b>
                    <span style='font-size:12.0pt;font-family:"Times New Roman",serif;color:black'>
                        AYDINLATMA
                        METNİ
                    </span>
                </b>
            </p>

            <p class=MsoNoSpacing align=center style='text-align:center;background:white'>
                <b>
                    <span style='font-size:12.0pt;font-family:"Times New Roman",serif;color:black'>&nbsp;</span>
                </b>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>Biz, </span>
                <span style='font-size:13.5pt;color:black'>Op.Dr Osman Cem YILMAZKliniği</span>
                <span style='font-size:12.0pt;color:black'>
                    olarak &quot;<b>Şirket</b>&quot;
                    olarak; hangi kişisel verilerinizi ne amaçlarla işleyeceğimizi size
                    anlatabilmek için bu Aydınlatma Metni’ni hazırladık. Aşağıda belirttiğimiz ve
                    tarafımıza sağladığınız kişisel verilerinizin her koşulda;
                </span>
            </p>

            <ul type=disc>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Duruma göre aşağıda belirtilen şekillerde elde
                        ettiğimiz kişisel verilerinizin,
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>Hukuki ilişkilerimiz kapsamında,</span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        İşlenmelerini gerektiren amaç çerçevesinde ve bu
                        amaçla bağlantılı, sınırlı ve ölçülü şekilde,
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Tarafımıza bildirdiğiniz veya bildirildiği
                        şekliyle kişisel verilerin doğruluğunu ve en güncel halini koruyarak,
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Kaydedileceğini, depolanacağını, muhafaza
                        edileceğini, yeniden düzenleneceğini, kanunen bu kişisel verileri talep
                        etmeye yetkili olan kurumlar ile paylaşılacağını ve KVKK’nın öngördüğü
                        şartlarda, yurtiçinde üçüncü kişilere aktarılacağını, devredileceğini,
                        sınıflandırılabileceğini ve KVKK’da sayılan sair şekillerde
                        işlenebileceğini bildiririz.
                    </span>
                </li>
            </ul>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <b>
                    <span style='font-size:12.0pt;color:black'>
                        HANGİ KİŞİSEL VERİLERİNİZİ
                        İŞLİYORUZ?
                    </span>
                </b>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    İş arayan üyelerimizle çalışan arayan
                    üyelerimizi aynı platformda birleştirerek istihdam yaratmayı amaçlayan
                    platformumuzda, bu amaçları gerçekleştirebilmek ve bazı araştırmalar ve
                    pazarlama faaliyetleri yaparak tüm üyelerimize daha iyi hizmet verebilmek için
                    zaman zaman kişisel verilerinizi işleyebilmekteyiz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Tarafımızca, bizimle paylaşmanız veya
                    gerekli olması halinde, işlemeye konu olabilecek kişisel verileriniz aşağıdaki
                    gibidir:
                </span>
            </p>

            <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0 width=614
                   style='width:460.7pt;border-collapse:collapse;border:none'>
                <tr>
                    <td width=151 valign=top style='width:113.4pt;border:solid black 1.0pt;
  padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <b>
                                <span style='font-size:12.0pt;color:black'>Kimlik Verisi</span>
                            </b>
                        </p>
                    </td>
                    <td width=463 valign=top style='width:347.3pt;border:solid black 1.0pt;
  border-left:none;padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <span style='font-size:12.0pt;color:black'>
                                Adınız, soyadınız, T.C. Kimlik
                                numaranız, doğum tarihiniz ve yeriniz, cinsiyetiniz, medeni durumunuz,
                                milliyetiniz
                            </span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width=151 valign=top style='width:113.4pt;border:solid black 1.0pt;
  border-top:none;padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <b>
                                <span style='font-size:12.0pt;color:black'>İletişim Verisi</span>
                            </b>
                        </p>
                    </td>
                    <td width=463 valign=top style='width:347.3pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <span style='font-size:12.0pt;color:black'>
                                E-posta adresiniz, adresiniz,
                                yaşadığınız il/ilçe, ev ve/veya cep telefon numaranız
                            </span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width=151 valign=top style='width:113.4pt;border:solid black 1.0pt;
  border-top:none;padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <b>
                                <span style='font-size:12.0pt;color:black'>Özel Nitelikli Kişisel Veri</span>
                            </b>
                        </p>
                    </td>
                    <td width=463 valign=top style='width:347.3pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <span style='font-size:12.0pt;color:black'>
                                Özgeçmişte yer vermeniz halinde dernek,
                                vakıf, sendika, siyasi parti üyeliklerine ait bilgiler, dini veya felsefi
                                görüşünüze, etnik kökeninize ve ırkınıza ait veya o konuda kanaat
                                oluşturabilecek bilgiler, sağlığınıza ilişkin bilgiler veya destek hattında
                                otomatik ses kayıt sistemine kaydedilen özel nitelikli kişisel verileriniz
                            </span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width=151 valign=top style='width:113.4pt;border:solid black 1.0pt;
  border-top:none;padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <b>
                                <span style='font-size:12.0pt;color:black'>Eğitim Verisi</span>
                            </b>
                        </p>
                    </td>
                    <td width=463 valign=top style='width:347.3pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <span style='font-size:12.0pt;color:black'>
                                Öğrenim durumu, sertifika ve diploma
                                bilgileri, uzmanlık bilgisi, yabancı dil bilgileri, eğitim ve beceriler,
                                katıldığı seminer ve kurslar, bilgisayar bilgisi
                            </span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width=151 valign=top style='width:113.4pt;border:solid black 1.0pt;
  border-top:none;padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <b>
                                <span style='font-size:12.0pt;color:black'>İş Deneyimi Verisi</span>
                            </b>
                        </p>
                    </td>
                    <td width=463 valign=top style='width:347.3pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <span style='font-size:12.0pt;color:black'>
                                Toplam tecrübe, çalışma durumu ve
                                unvanı, iş deneyimleri (firma isimleri, çalışmış olduğu dönemler, iş tanımı)
                            </span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width=151 valign=top style='width:113.4pt;border:solid black 1.0pt;
  border-top:none;padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <b>
                                <span style='font-size:12.0pt;color:black'>Görsel ve İşitsel Veri</span>
                            </b>
                        </p>
                    </td>
                    <td width=463 valign=top style='width:347.3pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <span style='font-size:12.0pt;color:black'>
                                Gerçek kişiye ait fotoğraf, selvi (video
                                CV), ses kayıtları
                            </span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width=151 valign=top style='width:113.4pt;border:solid black 1.0pt;
  border-top:none;padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <b>
                                <span style='font-size:12.0pt;color:black'>Diğer</span>
                            </b>
                        </p>
                    </td>
                    <td width=463 valign=top style='width:347.3pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  padding:.75pt .75pt .75pt .75pt'>
                        <p class=MsoNormal style='text-align:justify;background:white'>
                            <span style='font-size:12.0pt;color:black'>
                                Sürücü belgesi verileri, yetkinlikleri,
                                hobisi, maaş beklentisi, askerlik durumu, referans bilgileri (referans
                                kişisinin adı soyadı, unvanı, işyeri, telefonu, e-postası) ve varsa CV'sine
                                eklediği her türlü word, excel, sunum dosyaları, Profil ID, Login ID, IP
                                adresi, log kayıtları, İşveren Müşteriler’in adaylardan talep edebileceği ek
                                bilgiler
                            </span>
                        </p>
                    </td>
                </tr>
            </table>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>&nbsp;</span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <b>
                    <span style='font-size:12.0pt;color:black'>
                        KİŞİSEL VERİLERİNİZİ NE ŞEKİLDE VE
                        HANGİ SEBEPLERLE TOPLUYORUZ?
                    </span>
                </b>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Şirket olarak hukuki yükümlülüklerimizi
                    yerine getirmek, aramızdaki istihdam hizmeti sözleşmesinin, Şirket’e
                    başvuruyorsanız aramızda kurulabilecek iş akdinin ifası ve Şirket’in meşru
                    menfaati gereği sizden talep ettiğimiz kişisel verilerinizi, sizin bize fiziksel
                    veya elektronik ortamda iletmeniz, platformlarımıza bilgi, ses ve görüntü
                    girişi yapmanız ve internet ortamına 3. Kişilerin ulaşımına açık bilgi
                    kaydetmeniz suretiyle topluyoruz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Şirket’in size destek sağlayarak müşteri
                    memnuniyeti arttırmaya yönelik meşru menfaati gereği telefon görüşmelerimiz
                    sırasında elde ettiğimiz ses kayıtları aracılığıyla topluyoruz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Şirket’in platformunu geliştirmeye ve daha
                    efektif hale getirmeye yönelik meşru menfaati gereği Çerez Politikamızda da
                    detayları belirtildiği üzere web sitemizde kullanılan çerezler vasıtasıyla
                    kişisel verilerinizi elektronik olarak topluyoruz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <b>
                    <span style='font-size:12.0pt;color:black'>
                        KİŞİSEL VERİLERİNİZİ HANGİ
                        AMAÇLARLA İŞLİYORUZ?
                    </span>
                </b>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Yukarıda belirttiğimiz kişisel
                    verileriniz, size verdiğimiz istihdam hizmetine ilişkin bu Hizmet
                    Sözleşmesi’nin ifası için aşağıdaki amaçlarla işlenmektedir:
                </span>
            </p>

            <ul type=disc>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        İstihdam yaratmak ve işe alım sürecinize destek
                        vermek
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>Bütçe yönetimi ve raporlama yapmak</span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        İşe alım süreçlerinin yürütülmesi, kayda alınması
                        ve iyileştirilmesi
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        İş görüşmeleri esnasında kişinin beyan ettiği
                        tecrübelerinin, eğitim durumunun, yetkinliklerinin araştırma, gözlem ve
                        kaydının yapılması
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        İstihdam edilecek çalışan adayının
                        görevlendirileceği ilgili departmanın iş koşullarına uygun eğitim, nitelik
                        ve becerilerinin mevcudiyetinin tespiti
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>Çalışan Adayları hakkında referans alınması</span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Görüşme sonunda istihdamın gerçekleşmemesi
                        durumunda, ileride adayın uygun bir pozisyon için görüşmeye çağrılması
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>Şirket içi güvenliğin sağlanması</span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Size verdiğimiz hizmetin kalitesini arttırmak ve
                        kalite kontrolünü sağlamak
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Özgeçmişinizde yer verdiğiniz referans
                        kişileriyle verilerin teyit edilmesi
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Pozisyonla ne kadar örtüştüğünüzün doğrulanması
                        ve ileriye dönük teyit için özgeçmiş bilgilerinizin kaydedilmesi
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Kısa ya da uzun vadede ihtiyaç duymamız
                        ihtimaline karşı sizinle e-posta ortamında paylaştığımız teklif mektubunun
                        kayıt altına alınması
                    </span>
                </li>
            </ul>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Son olarak, hukuka ve usule uygun savcılık
                    talepleri ve mahkeme kararları gibi hukuki talepler aracılığıyla tarafımızdan
                    kişisel verilerinizin paylaşılması istendiğinde ve mevzuatta düzenlenmiş yasal
                    bildirimler gereği kişisel verilerinizi paylaşma yükümlülüğümüz bulunmaktadır.
                    Ayrıca kişisel verileriniz bizim de taraf olduğumuz bir uyuşmazlığa konu olduğu
                    takdirde savunma hakkımızı kullanabilmemiz için gerekli olan avukat, bilirkişi,
                    mahkeme gibi mecralarla ve kişilerle kişisel verilerinizi paylaşmamız
                    gerekebilir. Bu hukuki yükümlülüklerimizi yerine getirmek ve savunma hakkımızı
                    kullanabilmek amacıyla kişisel verilerinizi işleyebiliriz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <b>
                    <span style='font-size:12.0pt;color:black'>
                        KİŞİSEL VERİLERİNİZİ NERELERE
                        AKTARIYORUZ?
                    </span>
                </b>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Size verdiğimiz hizmeti en iyi şekilde
                    yerine getirebilmek için sürekli gelişmeye ve ilerlemeye gayret ediyoruz. Bunun
                    için kişisel verilerinizi aşağıdaki şekilde yurt içindeki ve yurt dışındaki
                    üçüncü kişilere aktarabilmekteyiz:
                </span>
            </p>

            <ul type=disc>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Çalışma saatlerimizin dışında size yardımcı
                        olabilmeleri&nbsp;özel nitelikli kişisel verileriniz de dahil olmak üzere
                        ilgili kişisel verilerinizi&nbsp;anlaşmalı olduğumuz Call Centerlara
                        (destek hattı hizmeti veren arama merkezlerine) aktarılabiliyoruz.
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Şirketimize çalışan adayı olarak başvurduğunuz
                        takdirde referans olarak gösterdiğiniz kişilerle teyitleşmek amacıyla söz
                        konusu kişilerle paylaşılabilmektedir.
                    </span>
                </li>
            </ul>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Ayrıca savunma hakkımızı kullanabilmek
                    amacıyla özel nitelikli kişisel verileriniz de dahil olmak üzere bütün kişisel
                    verilerinizi avukatlarımıza veya hukuki danışmanlarımıza aktarabiliriz ve bize
                    kişisel verilerinizin aktarılmasına ilişkin usulüne uygun yasal bir talep
                    geldiği takdirde özel nitelikli kişisel verileriniz de dahil olmak üzere bütün
                    kişisel verilerinizi aktarabiliriz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <b>
                    <span style='font-size:12.0pt;color:black'>HAKLARINIZ</span>
                </b>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    KVKK’nın 11. maddesi gereği bize şahsen,
                    kimliğinizi ispat etmeniz kaydıyla, kişisel verileriniz ile ilgili;
                </span>
            </p>

            <ul type=disc>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Şirket’in hakkınızda kişisel veri işleyip
                        işlemediğini öğrenmek, eğer işlemişse, buna ilişkin bilgi talep etmek,
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Kişisel verilerinizin işlenme amacını ve bunların
                        amacına uygun kullanılıp kullanılmadığı öğrenmek,
                    </span>
                </li>
                <li class=MsoNormal style='color:black;text-align:justify;background:white;
     text-autospace:ideograph-numeric ideograph-other'>
                    <span style='font-size:12.0pt'>
                        Kişisel verilerin yurtiçi veya yurtdışına
                        aktarılıp aktarılmadığı ve kimlere aktarıldığını öğrenmek haklarına
                        sahipsiniz.
                    </span>
                </li>
            </ul>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Ayrıca, Şirket’ten yanlış ve eksik kişisel
                    verilerinizin düzeltilmesini ve verilerinin aktarıldığı veya aktarılmış
                    olabileceği alıcıların bilgilendirilmesini talep etme hakkınız vardır.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Kişisel verilerinizin KVKK madde 7’de
                    öngörülen şartlar çerçevesinde verilerinizin imha edilmesini (silinmesini, yok
                    edilmesini veya anonim hale getirilmesini) Şirketten talep edebilirsiniz. Aynı
                    zamanda verilerin aktarıldığı veya aktarılabileceği 3. kişilerin söz konusu
                    imha talebiniz ile ilgili bilgilendirilmesini talep edebilirsiniz. Ancak imha
                    talebinizi değerlendirerek hangi yöntemin uygun olduğu somut olayın koşullarına
                    göre tarafımızca değerlendirilecektir. Bu bağlamda seçtiğimiz imha yöntemini
                    neden seçtiğimiz ile ilgili bizden her zaman bilgi talep edebilirsiniz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Münhasıran bir otomatik sistem
                    kullanılarak oluşturulmuş kişisel veri analizinizin sonuçlarına bu sonuçlar
                    çıkarlarınıza aykırıysa itiraz edebilirsiniz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Kişisel verilerinizin kanuna aykırı olarak
                    işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep
                    edebilirsiniz.
                </span>
            </p>

            <p class=MsoNormal style='text-align:justify;background:white'>
                <span style='font-size:12.0pt;color:black'>
                    Başvurunuzda yer alan talepleriniz, talebin
                    niteliğine göre en geç otuz gün içinde ücretsiz olarak sonuçlandırılacaktır.
                    Ancak, işlemin Şirket için ayrıca bir maliyeti gerektirmesi hâlinde, Kişisel
                    Verileri Koruma Kurulu tarafından Veri Sorumlusuna Başvuru Usul ve Esasları
                    Hakkında Tebliğ’de belirlenen tarifedeki ücret alınabilir.
                </span>
            </p>

        </div>
    </div>
</template>

<script>
    export default {}
</script>

<style scoped>
    /* Font Definitions */
    @font-face {
        font-family: Wingdings;
        panose-1: 5 0 0 0 0 0 0 0 0 0;
    }

    @font-face {
        font-family: "Cambria Math";
        panose-1: 2 4 5 3 5 4 6 3 2 4;
    }

    @font-face {
        font-family: Calibri;
        panose-1: 2 15 5 2 2 2 4 3 2 4;
    }
    /* Style Definitions */
    p.MsoNormal, li.MsoNormal, div.MsoNormal {
        margin: 0in;
        text-autospace: none;
        font-size: 11.0pt;
        font-family: "Times New Roman",serif;
    }

    p.MsoNoSpacing, li.MsoNoSpacing, div.MsoNoSpacing {
        margin: 0in;
        font-size: 11.0pt;
        font-family: "Calibri",sans-serif;
    }

    .MsoChpDefault {
        font-family: "Calibri",sans-serif;
    }

    .MsoPapDefault {
        margin-bottom: 8.0pt;
        line-height: 107%;
    }
    /* Page Definitions */
    @page WordSection1 {
        size: 595.3pt 841.9pt;
        margin: 70.85pt 70.85pt 70.85pt 70.85pt;
    }

    div.WordSection1 {
        page: WordSection1;
    }
    /* List Definitions */
    ol {
        margin-bottom: 0in;
    }

    ul {
        margin-bottom: 0in;
    }
</style>